import React, { useEffect, useState } from 'react'
import axios from 'axios'// npm i react-axios  => // npm install axios
import { useTable } from 'react-table' // npm i react-table
import UserData from './UserData'

const Standings1 = () => {

    const [stats, setStats] = useState([])
    const [fixtures, setFixture] = useState("https://api-football-v1.p.rapidapi.com/v3/standings")
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true)
        let cancel;
        axios.get(fixtures, {
            headers: {
                "X-RapidAPI-Key" : "ed5f66bf66msh3195b0687e916c5p11ad30jsndeaa1680f030",
                "X-RapidAPI-Host": "api-football-v1.p.rapidapi.com"
            },
            params: {season: '2022', league: '39'},

        },{
            cancelToken: new axios.CancelToken(c => cancel = c)
        })
            .then(response => {
              setLoading(false)
            console.log(response.data.response[0].league.standings[0])
            setStats(response.data.response[0].league.standings[0])
            
        }).catch((error) => {
            console.log(error)
        })

        return () => cancel()
    }, [fixtures])

    if (loading) return "LOADING..."
    
  return (
            <div className='container-fluid min-vh-100 mt-5'>
              <div className='container d-flex flex-column justify-content-center'>
              <h1 id='leage-title' className='text-dark text-center mb-5'>League Standings</h1>
                <table>
                    <thead className='bg-danger ms-2'>
                      <tr>
                        <th className='text-center'>Position</th>
                        <th className='text-center'>Club</th>
                        <th className='text-center'>Points</th>
                        <th className='text-center'>Wins</th>
                        <th className='text-center'>Draws</th>
                        <th className='text-center'>Lost</th>
                        <th className='text-center'>Played</th>
                      </tr>
                    </thead>
                    <tbody className='bg-dark text-white'>
                      <UserData stats={stats}/>
                    </tbody>
                </table>
              </div>
            </div>
  )
}


export default Standings1